import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/account_circle.svg'
import _imports_1 from '@/assets/img/arrow_down.svg'


const _withScopeId = n => (_pushScopeId("data-v-03e50980"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = { class: "contents__box info-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["component userinfo", {'open': _ctx.openUserInfo}])
  }, [
    _createElementVNode("div", {
      class: "contents__box user-box",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openUserInfo = !_ctx.openUserInfo))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openUserInfoPage()))
      }, "내 정보 수정"),
      _createElementVNode("button", {
        class: "button__blue logout-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout()))
      }, "로그아웃")
    ])
  ], 2))
}